import "react-toastify/dist/ReactToastify.min.css";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Route, Routes } from "react-router";
import LoginSiteMain from "../LoginSiteMain/LoginSiteMain.js";
import CollectionMain from "../../collection/collectionMain/collectionMain.js";
import { ToastContainer } from "react-toastify";
import "./style.css";
import SurveyMain from "../../Survey/SurveyMain/SurveyMain.js";
import LiveLoginSiteMain from "../LiveLoginSiteMain/LiveLoginSiteMain.js";
export default function Body(props) {
    return (React.createElement("div", { className: "router-main" },
        React.createElement(ToastContainer, null),
        React.createElement(BrowserRouter, null,
            React.createElement(Routes, null,
                React.createElement(Route, { path: "/c/:siteName", element: React.createElement(LoginSiteMain, null) }),
                React.createElement(Route, { path: "/c/:siteName/collection", element: React.createElement(CollectionMain, null) }),
                React.createElement(Route, { path: "/c/:siteName/survey/:surveyId", element: React.createElement(SurveyMain, null) }),
                React.createElement(Route, { path: "/c/:siteName/live", element: React.createElement(LiveLoginSiteMain, null) })))));
}
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(React.createElement(Body, null), document.body.querySelector("#container"));
